import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const resolveUrl = (url) => {
  if (!url) return "";
  if (url.includes("/api/files/") && !url.startsWith(process.env.REACT_APP_BACKEND_URL)) {
    const filePath = url.substring(url.indexOf("/api/files/"));
    return `${process.env.REACT_APP_BACKEND_URL}${filePath}`;
  }
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

const BeforeAfterSection = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/before-after`).then((r) => setItems(r.data)).catch((e) => console.error("Failed to load before/after items:", e));
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="py-24 md:py-32 bg-brand-surface relative noise-overlay" data-testid="before-after-section">
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="text-xs uppercase tracking-[0.2em] font-sans text-brand-gold mb-4">Transformations</p>
          <h2 className="font-serif text-3xl md:text-5xl text-brand-text tracking-tight">Before & After</h2>
          <div className="gold-line-long mx-auto mt-6" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
              className="border border-brand-border overflow-hidden group"
              data-testid={`before-after-${item.id}`}
            >
              <div className="grid grid-cols-2">
                <div className="relative">
                  <img src={resolveUrl(item.before_image)} alt={`${item.client_name} before`} className="w-full aspect-square object-cover" />
                  <span className="absolute bottom-2 left-2 font-sans text-[10px] uppercase tracking-wider bg-black/70 text-brand-text-muted px-2 py-0.5">Before</span>
                </div>
                <div className="relative">
                  <img src={resolveUrl(item.after_image)} alt={`${item.client_name} after`} className="w-full aspect-square object-cover" />
                  <span className="absolute bottom-2 left-2 font-sans text-[10px] uppercase tracking-wider bg-brand-gold/90 text-black px-2 py-0.5">After</span>
                </div>
              </div>
              <div className="p-4">
                <p className="font-sans text-sm font-medium text-brand-text">{item.client_name}</p>
                <p className="font-sans text-xs text-brand-gold">{item.service}</p>
                {item.description && <p className="font-sans text-xs text-brand-text-muted mt-1">{item.description}</p>}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
